import logoAilights from "../assets/ailights_crop.webp";
import Stack from "./Stack";
import {cameraFeatures} from "../data/mobileCameraCards";

function CameraSection() {
    return (
        <section
            id="camera"
            aria-label="Camera section"
            className="relative bg-fit bg-center pb-[8vw] md:pb-[4vw] 4xl:bg-no-repeat 4xl:bg-cover"
            style={{ backgroundImage: 'url(/images/field_ailights.webp)' }}
        >
            <div className="flex flex-col items-center">
                <div className="
                        flex justify-center mb-6 mt-[16vw]
                        lg:mt-32
                ">
                    <img src={logoAilights} alt="Logo Ailights" className="
                        max-w-[54vw]
                        md:max-w-[32vw]
                        lg:max-w-[24vw]
                    "/>
                </div>
                <div className="
                    flex justify-center
                    text-[3.2vw]
                    md:text-[2.5vw]
                ">
                    <h2 className="font-[900] text-light">
                        Lo sport dilettantistico come{" "}
                        <span className="font-[900] text-yellow">
                            non lo avevi mai visto
                        </span>
                    </h2>
                </div>
                <div className="
                    hidden justify-center mt-[10vw] mb-[4vw] z-10
                    lg:flex
                ">
                    <Stack/>
                </div>
                {cameraFeatures.map(({ id, title, description, image }) => (
                    <div
                        key={id}
                        className="
                            border-t border-light flex flex-col items-center text-light mt-[4vw] w-4/5 relative text-center
                            md:flex-row md:items-start md:text-left md:mb-0
                            lg:hidden
                        "
                        style={{
                            backgroundImage:`linear-gradient(to right, transparent 0%, rgba(0,0,0,0.6) 10%, rgba(0,0,0,0.6) 90%, transparent 100%)`
                        }}
                    >
                        <div className="flex w-1/4 md:hidden">
                            <img src={image} alt="Brand example" className="rounded-md"/>
                        </div>
                        <div className="
                                flex items-start
                                md:flex-shrink-0 md:w-2/6 md:gap-x-[2vw] md:whitespace-pre-line
                        ">
                            <span className="hidden font-semibold text-sm md:block">{id}.</span>
                            <h2 className="text-2xl font-[900]">{title}</h2>
                        </div>

                        <div className="
                                text-sm leading-relaxed
                                md:w-3/6
                        ">
                            <p>{description}</p>
                        </div>

                        <div className="
                                justify-end self-center hidden
                                md:flex md:w-1/6
                        ">
                            <img src={image} alt="Brand example" className="w-1/2 rounded-md" />
                        </div>
                    </div>
                ))}

            </div>
        </section>
    );
}

export default CameraSection;
